import { html, css } from 'lit-element';
import { BaseElement } from './BaseElement';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { API, EVENT_TYPE_LOGIN_STATUS } from '../API';

const _api = Symbol();
const _statusHandler = Symbol();

export class MainNavigation extends BaseElement {
	constructor() {
		super();

		this.library.add(faBars);

		this[_statusHandler] = () => this.requestUpdate();

	}
	static get styles() {
		return [
			...BaseElement.styles,
			css`
				nav {
					border: var(--theme-border, 1px solid black);
					background: var(--theme-background, white);
					border-radius: 0.25em;
					margin-bottom: 0.5em;
				}
				button.toggle {
					display: none;
				}
				ul {
					margin: 0;
					padding: 0;
					display: flex;
				}
				li {
					list-style-type: none;
					padding: 0;
					margin: 0;
				}
				a {
					text-decoration: none;
					padding: 0.25em;
					display: inline-block;
					transition: all 0.25s;
					background-color: var(--theme-background, red);
					border-radius: 0.25em;
				}
				a:hover {
					background-color: var(--theme-background-hover, red);
				}
				@media only screen and (max-width: 500px) {
					button.toggle {
						display: inline-block;
						align-self: flex-start;
					}
					ul {
						flex-direction: column;
					}
					li {
						margin: 0;
					}
					a {
						display: block;
						border-radius: 0.25em;
					}
				}
			`
		];
	}
	get api() {
		return this[_api];
	}
	set api(v) {
		if(v !== null && !(v instanceof API))
			throw new TypeError('api must be an instance of API.');
		this[_api] = v;
	}
	connectedCallback() {
		super.connectedCallback();

		this.emit('get-api', { callback: api => this.api = api });

		this.api.on(EVENT_TYPE_LOGIN_STATUS, this[_statusHandler]);
	}
	disconnectedCallback() {
		super.disconnectedCallback();

		this.api.off(EVENT_TYPE_LOGIN_STATUS, this[_statusHandler]);

		this.api = null;
	}
	render() {
		return html`
			<nav>
				<ul>
					<button class="toggle">
						<i class="icon fas fa-bars"></i>
					</button>
					<li><a href="/">About</a></li>
					<li><a href="/search-patients">Search Patients</a></li>
					${this.api.isAdmin ? html`<li><a href="/admin">Admin</a></li>` : ''}
				</ul>
			</nav>
		`;
	}
}

customElements.define('pp-main-navigation', MainNavigation);
